import { IOurResults } from "@components/projects/level01/level01.state";
import { FC } from "react";
import styles from "./our-results.module.scss";
import Image from "next/image";
import Level01Animation from '@components/projects/level01/animations';
import animations from '@components/projects/level01/animations/animations.module.scss';

interface OurResultsSectionProps {
  section: IOurResults;
}

const OurResultsSection: FC<OurResultsSectionProps> = ({ section }) => {
    return (
       <Level01Animation render={(ref) => (
         <div className={styles.container}>
             <section ref={ref} className={`${styles.section} ${animations.scroll__animation}`}>
                 <div className={styles.section__content}>
                     <h2 className={styles.section__title}>{section.title}</h2>
                     <p className={styles.section__subtitle}>{section.subtitle}</p>
                     <div className={styles.section__main}>
                         <div className={styles.section__list}>
                             {section.list.map((item) => (
                               <div key={item.text} className={styles.section__list_item}>
                                   <Image src={item.imageUrl} alt={item.text} width={32} height={24}
                                          layout={'fixed'}/>
                                   <p className={styles.section__list_text}>{item.text}</p>
                               </div>
                             ))}
                         </div>
                     </div>
                 </div>
                 <div className={styles.section__image}>
                     <div className={styles.section__image_container}>
                         <Image src={section.imageUrl} alt={section.title} layout={'fill'}/>
                     </div>
                 </div>
             </section>
         </div>
       )}/>
    )
}

export default OurResultsSection;
